var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("商品を選ぶ")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("section", { staticClass: "select_category" }, [
                  _c("div", { staticClass: "product_search_cond" }, [
                    _c("div", { staticClass: "product_search_act_square" }, [
                      _c("div", [
                        _vm._v("現在の検索条件:" + _vm._s(_vm.searchCond))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "product_search_count" }, [
                        _vm._v("該当商品 " + _vm._s(_vm.productCnt) + "件")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "product_button" }, [
                      _c(
                        "div",
                        {
                          staticClass: "square_btn_black",
                          on: { click: _vm.onSearch }
                        },
                        [_vm._v("絞り込む")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "square_btn_white",
                          on: { click: _vm.onReset }
                        },
                        [_vm._v("条件リセット")]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.productList.length > 0
                  ? _c(
                      "section",
                      { ref: "product_top", attrs: { id: "product_list" } },
                      _vm._l(_vm.productList, function(product, index) {
                        return _c(
                          "div",
                          {
                            key: "product-" + index,
                            staticClass: "product",
                            attrs: { value: product },
                            on: {
                              click: function($event) {
                                _vm.customize(product)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.getImage(product.dcFdImage) }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "product_detail" }, [
                              _c("div", [
                                _c("p", { staticClass: "bold" }, [
                                  _vm._v(_vm._s(product.dcFdName))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "pickup bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.productSize(
                                        product.dcMinWidth,
                                        product.dcMaxWidth
                                      )
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      })
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("dd-pager", {
                  attrs: {
                    pageNo: _vm.pageNo,
                    dataCountPerPage: 18,
                    totalDataCount: _vm.dcFileDataList.length
                  },
                  on: { paging: _vm.paging }
                }),
                _vm._v(" "),
                _vm.dcFileDataList.length <= 0
                  ? _c("div", [_vm._v("該当する商品がありません。")])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31db693c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31db693c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcCategory.vue
// module id = null
// module chunks = 